module.exports = __webpack_public_path__ + "img/icon-lock-white.809ed25c.svg";